module.exports = __webpack_public_path__ + "static/grupo.min-f71638776747c2565a6e7c76e69f60a5.png";